// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xHTb1","colBig":"styles_colBig__3jDtK","colSmall":"styles_colSmall__2ms64","shopifyNameWrapper":"styles_shopifyNameWrapper__1gR7G"};